<script setup>
/* eslint-disable */
import { getFilePreviewUrl, downloadFileApi } from '@/utils/api'

const props = defineProps({
  fileList: {
    type: Array,
    default: () => []
  }
})

// 下载方法
const downloadFile = (fileId) => {
  console.log('downloadFile:',fileId)
  window.open(downloadFileApi(fileId), '_blank')
}

// 获取在线预览地址（微软接口，支持所有文档）
const getOnlinePreviewUrl = (url) => {
  console.log('getOnlinePreviewUrl', url)
  return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`
}

// 文件类型判断
const isImage = (t) => ['img', 'image', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'].includes(t?.toLowerCase())
const isVideo = (t) => ['video', 'mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv', 'rmvb', 'mpeg', 'mpg'].includes(t?.toLowerCase())
const isAudio = (t) => ['audio', 'mp3', 'wav', 'flac', 'aac', 'ogg', 'wma'].includes(t?.toLowerCase())
const isPdf   = (t) => t?.toLowerCase() === 'pdf'
const isWord  = (t) => ['doc', 'docx'].includes(t?.toLowerCase())
const isExcel = (t) => ['xls', 'xlsx', 'csv'].includes(t?.toLowerCase())
const isPpt   = (t) => ['ppt', 'pptx'].includes(t?.toLowerCase())
</script>

<template>
  <div class="file-viewer">
    <div v-for="item in fileList" :key="item.fileId" class="preview-item">

      <!-- 图片 -->
      <div v-if="isImage(item.fileType)">
        <el-image :src="getFilePreviewUrl(item.fileId)" style="width:100%;max-height:600px"/>
        <div class="name">{{ item.fileName }}</div>
      </div>

      <!-- 视频 -->
      <div v-else-if="isVideo(item.fileType)">
        <video controls preload="metadata" style="width:100%;max-height:600px">
          <source :src="getFilePreviewUrl(item.fileId)" />
          您的浏览器不支持视频播放
        </video>
        <div class="name">{{ item.fileName }}</div>
      </div>

      <!-- 音频 -->
      <div v-else-if="isAudio(item.fileType)">
        <audio controls style="width:100%">
          <source :src="getFilePreviewUrl(item.fileId)" />
          您的浏览器不支持音频播放
        </audio>
        <div class="name">{{ item.fileName }}</div>
      </div>

      <!-- PDF -->
      <div v-else-if="isPdf(item.fileType)">
        <iframe :src="getFilePreviewUrl(item.fileId)" width="100%" height="600" frameborder="0"></iframe>
      </div>

      <!-- WORD 预览 -->
      <div v-else-if="isWord(item.fileType)">
        <iframe :src="getOnlinePreviewUrl(getFilePreviewUrl(item.fileId))" width="100%" height="600" frameborder="0"></iframe>
      </div>

      <!-- PPT 预览 -->
      <div v-else-if="isPpt(item.fileType)">
        <iframe :src="getOnlinePreviewUrl(getFilePreviewUrl(item.fileId))" width="100%" height="600" frameborder="0"></iframe>
      </div>

      <!-- EXCEL 预览 -->
      <div v-else-if="isExcel(item.fileType)">
        <iframe :src="getOnlinePreviewUrl(getFilePreviewUrl(item.fileId))" width="100%" height="600" frameborder="0"></iframe>
      </div>

      <!-- 其他文件 → 下载 -->
      <div v-else>
        <el-button type="primary" link @click="downloadFile(item.fileId)">
          {{ item.fileName }}
        </el-button>
      </div>

    </div>
  </div>
</template>

<style scoped>
.file-viewer { width: 100%; }
.preview-item { margin-bottom: 20px; text-align: center; }
.name { margin-top: 8px; font-size: 14px; color: #666; }
iframe { width: 100%; height: 600px; border: 1px solid #eee; }
</style>